/** Lives indicator shared by the games — filled hearts minus mistakes made. */
export function Hearts({ mistakes, max }: { mistakes: number; max: number }) {
  const left = Math.max(0, max - mistakes);
  return (
    <span className="vn-hearts" role="img" aria-label={`${left} of ${max} hearts left`}>
      {Array.from({ length: max }).map((_, i) => (
        <span key={i} className="vn-hearts__pip" aria-hidden="true">
          {i < left ? '❤️' : '🤍'}
        </span>
      ))}
    </span>
  );
}
